import axios from './utils/axios';
import { utils } from 'gipsy-misc';

var cancelTokens = {};

export var synchronize = function synchronize(email) {
  var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var endpoint = active ? '/contacts/sync/' + email + '/active' : '/contacts/sync/' + email + '/passive';
  return axios.post(endpoint);
};

export var unsync = function unsync(email) {
  var endpoint = '/contacts/unsync/' + email;
  return axios.post(endpoint);
};

export var get = function get() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var contactOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  cancelTokens.get = require('axios').CancelToken.source();
  var endpoint = '/suggest-assignee';
  endpoint = utils.request.appendToUrl(endpoint, { query: query, contactOnly: contactOnly });
  return axios.get(endpoint, { cancelToken: cancelTokens.get.token });
};

export var cancel = function cancel(method) {
  if (cancelTokens[method] && cancelTokens[method].cancel) {
    cancelTokens[method].cancel();
  }
};
//# sourceMappingURL=contact.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/contact.js
// module id = 1076
// module chunks = 0